import { clearCache } from '@/global';
import useIntl from '@/hooks/useIntl';
import styles from '@/pages//styles.less';
import { RedoOutlined } from '@ant-design/icons';
import { Button, Spin, Typography } from 'antd';
import { useEffect, useState } from 'react';
import Logger from './services/Logger';

const { Title } = Typography;

const Refresh: React.FC = () => {
    const [haveTimeout, setHaveTimeout] = useState<boolean>(false);
    const t = useIntl();

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setHaveTimeout(true);
            if (!!window.navigator && !!window.navigator['connection']) {
                const { downlink, rtt, effectiveType } = window.navigator['connection'];
                Logger.startSession({
                    downlink: `${downlink}Mbps`,
                    rtt: `${rtt}ms`,
                    effectiveType,
                });
                Logger.log_warning(`Component <Refresh /> have reached its limit (10sec) on page ${location.pathname}`);
                Logger.endSession();
            }
        }, 10000);
        return () => clearTimeout(timeoutId);
    }, []);

    const onClick = () => {
        clearCache();
        window.location.reload();
    };

    return (
        <div className={styles.pageLoaderContainer}>
            <Spin size="large" spinning></Spin>
            <div className={`${styles.infoWrapper} ${haveTimeout ? styles.visible : styles.nonVisible}`}>
                <Title level={4}>{t('pages.loading.title')}</Title>
                <Button className={styles.button} type="primary" icon={<RedoOutlined />} size="large" onClick={onClick}>
                    {t('pages.loading.refresh')}
                </Button>
            </div>
        </div>
    );
};

export default Refresh;
